import SearchModal from 'components/searchmodal/SearchModal';
import { CustomButton } from 'components/shared/CustomButton';
import { IQuestionTypeModel } from 'models/QuestionType.Model'
import React, { InputHTMLAttributes, useState } from 'react'
import { Col, Modal, ModalBody, Row } from 'reactstrap'


interface inputProps extends InputHTMLAttributes<HTMLInputElement> {
    data: Array<IQuestionTypeModel>,
    item: IQuestionTypeModel,
    index: any,
    elementRef: any
    clickHandler: any,
}


function PopupQuestions({ data, item, index, elementRef, clickHandler, ...rest }: inputProps, ref) {
    const [showModel, setShowModel] = useState(false);
    const [selectedValue, setSelectedValue] = useState<IQuestionTypeModel>({} as IQuestionTypeModel);

    const subQuestions = data.filter(options => options.ParentId === item.Identifier);
    const selectedDisplayName = subQuestions.find(x => x.Response === true)?.DisplayName;
    const selectedId = subQuestions.find(x => x.Response === true)?.Id;
    return (
        <React.Fragment>
            <Row>
                <Col ref={elementRef} sizeXl="12" sizeLg="12" sizeMd="12" sizeSm="12" sizeXs="12" key={index} className="pt-0 mt-0">
                    <div className={`d-flex ${item.EnumName == "Year_of_Purchase_or_Make" && "mb-3"}`}>
                        <div className="d-flex pt-0 mt-0 bg-color-white cursor-pointer" onClick={() => setShowModel(true)}>
                            <p style={{ whiteSpace:"pre-line" }} className="questionaire-question">{item.DisplayName}&nbsp;:</p>
                        </div>
                            <div className="d-flex pt-0 mt-0 bg-color-white cursor-pointer" onClick={() => setShowModel(true)}>
                                {(selectedValue?.DisplayName || selectedDisplayName) &&
                                    <p style={{ marginLeft: '20px', color: "#3880ff",whiteSpace:"pre-line" }} className="questionaire-question Sub_Questionaire text-dofy fw-semibold">{selectedValue.DisplayName ? selectedValue.DisplayName : selectedDisplayName}</p>
                                }
                            </div>
                        {/* <CustomButton type={'button'} btnClassName={`"btn-sm btn-light w-xs dofy-admin-font-xs`} iconClasssName={undefined} name={'Configure'} /> */}

                        <div className="mx-3 cursor-pointer" onClick={() => setShowModel(true)}>
                            <i className='bx bx-link-external font-size-16 me-2 fw-semibold'></i>

                        </div>
                    </div>
                    <div>
                        <Modal isOpen={showModel} swipeToClose={true} onDidDismiss={() => setShowModel(false)} scrollable centered size="sm">
                            <ModalBody style={{ height: "450px" }}>
                                <SearchModal showModel={setShowModel} data={subQuestions} index={index} elementRef={elementRef}
                                    clickHandler={clickHandler} selected={setSelectedValue} defaultSelected={selectedValue} heading={item} selectedId={selectedId} />
                            </ModalBody>
                        </Modal>
                    </div>
                </Col>
            </Row>
        </React.Fragment>
    )
}

export default PopupQuestions
